export interface ImageDropLayoutInput {
  count: number;
  anchorCenter: { x: number; y: number };
  cellWidth: number;
  cellHeight: number;
  gap: number;
}

export function layoutImageDropTopLeftPositions(input: ImageDropLayoutInput): { x: number; y: number }[] {
  const { count, anchorCenter, cellWidth, cellHeight, gap } = input;
  if (count <= 0) return [];

  const cols = Math.min(count, Math.max(1, Math.ceil(Math.sqrt(count))));
  const rows = Math.ceil(count / cols);
  const totalW = cols * cellWidth + (cols - 1) * gap;
  const totalH = rows * cellHeight + (rows - 1) * gap;
  const originX = anchorCenter.x - totalW / 2;
  const originY = anchorCenter.y - totalH / 2;

  const positions: { x: number; y: number }[] = [];
  for (let i = 0; i < count; i += 1) {
    const col = i % cols;
    const row = Math.floor(i / cols);
    positions.push({
      x: originX + col * (cellWidth + gap),
      y: originY + row * (cellHeight + gap),
    });
  }
  return positions;
}
